import React from "react";

import { CaseTemplateDropdown } from "src/cases/common/CaseTemplateDropdown";
import { useCaseTemplatesForWorkspace } from "src/cases/queries/templates";

type TemplateSelection = {
  templateId: string;
  versionId: string;
};

type WorkspaceTemplateSelectorProps = {
  error?: boolean;
  value: TemplateSelection;
  workspaceBaseUrl: string | undefined;
  onChange: (value: TemplateSelection) => void;
};

export const WorkspaceTemplateSelector: React.FC<
  WorkspaceTemplateSelectorProps
> = ({ error, value, workspaceBaseUrl, onChange }) => {
  const { data: templates = [], isLoading: isLoadingTemplates } =
    useCaseTemplatesForWorkspace(workspaceBaseUrl, {
      enabled: !!workspaceBaseUrl,
    });

  const getPlaceholder = () => {
    if (!workspaceBaseUrl) {
      return "Select workspace first";
    }
    if (!isLoadingTemplates && templates.length === 0) {
      return "No templates available";
    }
    return "Select template and version";
  };

  const isDisabled =
    !workspaceBaseUrl || isLoadingTemplates || templates.length === 0;

  return (
    <CaseTemplateDropdown
      className="w-full"
      dataLoc="create-from-existing-template-selector"
      disabled={isDisabled}
      error={error}
      options={templates}
      placeholder={getPlaceholder()}
      selected={value.templateId && value.versionId ? value : undefined}
      onSelect={onChange}
    />
  );
};
